export default __webpack_public_path__ + "static/media/Table-Pcheck.5ae005f6.svg";